<template>
  <div class="container">
    <div class="main_box">
      <!-- 搜索框 -->
      <section class="search_box" @click="toSearch" v-if="dataList.length && loaded">
        <img src="../../assets/images/search.png" />
        <span>搜索政策关键字</span>
      </section>
      <section class="list_box">
        <scroll v-if="dataList.length && loaded" :data="dataList" :allLoaded="allLoaded" @pulldown="loadData" @loadUp="loadup">
          <section class="list_item" @click="toPolicyDetail(item.id)" v-for="(item,index) in dataList" :key="index">
            <h2 class="over_two_lines">{{item.title}}</h2>
            <section class="item_bottom">
              <p class="item_bottom_left">{{item.createTime | timeType}}</p>
              <section class="item_bottom_labal">
                <span v-for="cur in item.tagName" :key="cur"># {{cur}}</span>
              </section>
            </section>
          </section>
        </scroll>
        <no-message v-if="!dataList.length && loaded"></no-message>
      </section>
    </div>
  </div>
</template>

<script>
import Scroll from "../../components/scroll";
import util from "../../utils/util";
import { getPolicyByTypeCode } from "../../utils/api";
import NoMessage from '../../components/nomessage';
import { mapState } from 'vuex';
export default {
  name: "policyList",
  components: {
    Scroll,
    NoMessage
  },
  data() {
    return {
      allLoaded: false,
      loaded:false,
      dataList: [],
      typeCode:'',
      key:'',
      pageNo:1,
      pageSize:10
    };
  },
  filters:{
    timeType(val){
      return util.formatTime(new Date(Number(val)),4)
    }
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  created(){
    this.typeCode = this.$route.query.typeCode;
    this.getPolicyByTypeCode();
  },
  methods: {
    getPolicyByTypeCode(){
      util.showLoading()
      this.allLoaded = false
      let params = {
        typeCode:this.typeCode,
        marketId:this.common.marketInfo.id,
        title:this.key,
        pageNo:this.pageNo,
        pageSize:this.pageSize
      }
      getPolicyByTypeCode(params).then( res =>{
        console.log(res)
        this.loaded = true
        if(res.res.code === 10000 && res.body && res.body.page){
          let dataList = res.body.page.rows || []
          if(dataList.length !== 10){
            this.allLoaded = true
          }
          dataList.forEach(item=>{
            if(item.tagName){
              item.tagName = item.tagName.split(/[\s+,，]/g).slice(0,2)
            }
          })
          if(this.pageNo === 1){
            this.dataList = dataList;
          }else{
            this.dataList = [...this.dataList,...dataList]
          }
        }else{
          util.showToast(res.res.msg)
        }
        util.hideLoading()
      })
    },
    toSearch() {
      this.$router.push(`/policySearch?typeCode=${this.typeCode}`);
    },
    toPolicyDetail(id){
      this.$router.push(`/policyDetail?id=${id}`);
    },
    // 上拉加载
    loadup() {
      if (this.allLoaded) {
        return;
      }
      this.pageNo++;
      this.getPolicyByTypeCode();
    },
    // 下拉刷新
    loadData() {
      this.pageNo = 1;
      this.getPolicyByTypeCode();
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  background: #fff;
  width: 100%;
}
.main_box{
  height: 100vh;
  width:100%;
  display:flex;
  flex-direction: column;
}
.search_box {
  margin: 26px 28px;
  height: 68px;
  background: rgba(244, 244, 244, 1);
  border-radius: 8px;
  .flex();
  align-items: center;
  flex-shrink: 0;
  img {
    display: block;
    width: 44px;
    height: 44px;
    margin: 0 16px 0 14px;
  }
  span {
    font-size: 28px;
    color: rgba(201, 201, 201, 1);
  }
}
.list_box {
  position:absolute;
  top:120px;bottom:0;left:0;right:0;
  .list_item {
    padding: 28px;
    .borderB();
    h2 {
      font-size: 32px;
      color: rgba(24, 24, 24, 1);
      line-height: 44px;
      height: 88px;
      margin-bottom: 18px;
      word-break: break-all;
    }
    .item_bottom {
      .flex();
      align-items: center;
      .item_bottom_left {
        font-size: 28px;
        color: rgba(153, 153, 153, 1);
        line-height: 40px;
      }
      .item_bottom_labal {
        flex: 1;
        .flex();
        justify-content: flex-end;
        span {
          display: block;
          margin-left: 10px;
          // min-width: 160px;
          padding:0 10px;
          background: rgba(235, 239, 245, 1);
          border-radius: 4px;
          font-size: 24px;
          color: rgba(60, 100, 159, 1);
          line-height: 34px;
          text-align: center;
        }
      }
    }
  }
}
</style>